// Функция для удаления нестандартных портов из URL
const removeNonStandardPort = (url: string): string => {
  // Если URL не начинается с http, возвращаем как есть (относительный путь)
  if (!url.startsWith('http')) {
    return url
  }
  
  try {
    const urlObj = new URL(url)
    const port = urlObj.port
    
    // Если порт нестандартный (не 80, не 443, и не пустой), убираем его
    if (port && port !== '80' && port !== '443') {
      urlObj.port = ''
    }
    
    return urlObj.toString()
  } catch (e) {
    // Если не удалось распарсить URL, используем regex замену
    console.warn('Failed to parse URL, using regex fallback:', url)
    return url.replace(/:(\d+)(?=\/|$)/g, (match, port) => {
      const portNum = parseInt(port)
      if (portNum === 80 || portNum === 443) {
        return match
      }
      return ''
    })
  }
}

// Определяем API URL
// В Telegram Mini App используем полный URL, если указан
// Иначе используем относительный путь (для веб через nginx proxy)
const getApiUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL
  
  // Если URL начинается с http, проверяем и убираем нестандартные порты
  if (envUrl && envUrl.startsWith('http')) {
    const cleanedUrl = removeNonStandardPort(envUrl)
    // Убираем двойные слэши в пути (но не после ://)
    return cleanedUrl.replace(/([^:]\/)\/+/g, '$1')
  }
  
  // Если запущено в Telegram и URL относительный, используем полный URL
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    // В Telegram Mini App относительные пути могут не работать
    // Используем текущий origin + путь (БЕЗ порта!)
    const currentOrigin = window.location.origin
    // Убираем порт, если он есть (например, :8000)
    let originWithoutPort = removeNonStandardPort(currentOrigin)
    const apiPath = envUrl || '/api'
    
    // Нормализуем путь: убираем ведущий слэш, если есть
    const cleanApiPath = apiPath.startsWith('/') ? apiPath : `/${apiPath}`
    // Убираем завершающий слэш из origin, если есть
    const cleanOrigin = originWithoutPort.replace(/\/+$/, '')
    // Собираем URL и убираем двойные слэши
    const fullUrl = `${cleanOrigin}${cleanApiPath}`.replace(/([^:]\/)\/+/g, '$1')
    
    console.log('Telegram mode: API_URL =', fullUrl, 'from origin:', currentOrigin, 'apiPath:', apiPath)
    return fullUrl
  }
  
  // Для веб используем относительный путь (будет проксироваться через nginx)
  return envUrl || '/api'
}

export const API_URL = getApiUrl()

// Логирование для отладки
if (typeof window !== 'undefined') {
  console.log('API_URL determined:', API_URL, {
    envUrl: import.meta.env.VITE_API_URL,
    origin: window.location.origin,
    href: window.location.href,
    isTelegram: !!window.Telegram?.WebApp,
  })
}

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  DAILY_LOGS: '/daily-logs',
  WEEKLY_SUMMARIES: '/weekly-summaries',
  TEAM: '/team',
  ANALYTICS: '/analytics',
  PROFILE: '/profile',
  ADMIN: '/admin',
  GOALS: '/goals',
} as const

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
} as const
